import { render, staticRenderFns } from "./productLicense.vue?vue&type=template&id=3c0bb250&scoped=true"
import script from "./productLicense.vue?vue&type=script&lang=js"
export * from "./productLicense.vue?vue&type=script&lang=js"
import style0 from "./productLicense.vue?vue&type=style&index=0&id=3c0bb250&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0bb250",
  null
  
)

export default component.exports